import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { OrderRestaurantBranchResponse } from '../../types/orders';

interface AcceptOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: (branchId: number) => void;
  branches: OrderRestaurantBranchResponse[];
  loading?: boolean;
}

const AcceptOrderModal: React.FC<AcceptOrderModalProps> = ({
  isOpen,
  onClose,
  onAccept,
  branches,
  loading = false
}) => {
  const { t } = useTranslation();
  const [selectedBranchId, setSelectedBranchId] = useState<number | ''>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedBranchId && typeof selectedBranchId === 'number') {
      onAccept(selectedBranchId);
    }
  };

  const handleClose = () => {
    setSelectedBranchId('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.acceptOrder.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div className="modal-form-group">
          <label htmlFor="branch">{t('modals.acceptOrder.selectBranch')}</label>
          <select
            id="branch"
            value={selectedBranchId}
            onChange={(e) => setSelectedBranchId(e.target.value ? parseInt(e.target.value) : '')}
            required
            disabled={loading}
          >
            <option value="">{t('modals.acceptOrder.chooseBranch')}</option>
            {branches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.name} - {branch.representativeName}
              </option>
            ))}
          </select>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.acceptOrder.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button success"
            disabled={loading || !selectedBranchId}
          >
            {loading ? t('modals.acceptOrder.accepting') : t('modals.acceptOrder.accept')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AcceptOrderModal;